(() => {
  const root = document.querySelector('[data-fp-clean-collection]');
  if (!root) return;

  root.addEventListener('click', (event) => {
    const close = event.target.closest('[data-fpcc-close]');
    if (close) {
      const drawer = root.querySelector('[data-fpcc-filter]');
      if (drawer) drawer.removeAttribute('open');
    }
  });

  const loader = root.querySelector('[data-fpcc-load]');
  const grid = root.querySelector('[data-fpcc-grid]');
  if (!loader || !grid || !loader.dataset.nextUrl || !('IntersectionObserver' in window)) return;

  let loading = false;

  const observer = new IntersectionObserver(async (entries) => {
    if (!entries[0]?.isIntersecting || loading) return;
    const nextUrl = loader.dataset.nextUrl;
    if (!nextUrl) {
      observer.disconnect();
      return;
    }

    loading = true;
    loader.classList.add('is-loading');

    try {
      const response = await fetch(nextUrl, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection page request failed');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('[data-fpcc-grid]');
      const nextLoader = doc.querySelector('[data-fpcc-load]');

      if (nextGrid) {
        const fragment = document.createDocumentFragment();
        Array.from(nextGrid.children).forEach((item) => fragment.appendChild(item));
        grid.appendChild(fragment);
      }

      loader.dataset.nextUrl = nextLoader?.dataset.nextUrl || '';
      document.dispatchEvent(new CustomEvent('collection:grid:rendered', {
        detail: { container: grid }
      }));

      if (!loader.dataset.nextUrl) observer.disconnect();
    } catch (error) {
      observer.disconnect();
    } finally {
      loading = false;
      loader.classList.remove('is-loading');
    }
  }, { rootMargin: '500px 0px' });

  observer.observe(loader);
})();